<template>
  <div
    class="dd-container container"
    @contextmenu="handlePaste($event)"
  >
    <p class="title">{{$t('artists')}}</p>

    <section
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="300"
      infinite-scroll-immediate-check="false"
      v-infinite-scroll="loadMore"
    >
      <div class="list-wrap">
        <nuxt-link
          :to="localePath('/artists/' + item.id)"
          class="item-wrap"
          :key="item.id"
          v-for="item in list"
        >
          <img
            class="normal-img"
            :alt="item.name"
            v-lazy="item.img"
            src="~/assets/img/blank.png"
          >
          <p>{{item.name}}</p>
        </nuxt-link>
      </div>
    </section>

    <div
      class="loading"
      v-show="loading"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="48px"
        height="60px"
        viewBox="0 0 24 30"
        style="enable-background:new 0 0 50 50"
        xml:space="preserve"
      >
        <rect
          x="0"
          y="9.22656"
          width="4"
          height="12.5469"
          fill="#e5e5e5"
        >
          <animate
            attributeName="height"
            attributeType="XML"
            values="5;21;5"
            begin="0s"
            dur="0.6s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="y"
            attributeType="XML"
            values="13; 5; 13"
            begin="0s"
            dur="0.6s"
            repeatCount="indefinite"
          />
        </rect>
        <rect
          x="10"
          y="5.22656"
          width="4"
          height="20.5469"
          fill="#e5e5e5"
        >
          <animate
            attributeName="height"
            attributeType="XML"
            values="5;21;5"
            begin="0.15s"
            dur="0.6s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="y"
            attributeType="XML"
            values="13; 5; 13"
            begin="0.15s"
            dur="0.6s"
            repeatCount="indefinite"
          />
        </rect>
        <rect
          x="20"
          y="8.77344"
          width="4"
          height="13.4531"
          fill="#e5e5e5"
        >
          <animate
            attributeName="height"
            attributeType="XML"
            values="5;21;5"
            begin="0.3s"
            dur="0.6s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="y"
            attributeType="XML"
            values="13; 5; 13"
            begin="0.3s"
            dur="0.6s"
            repeatCount="indefinite"
          />
        </rect>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      loading: false
    }
  },
  async fetch ({ store, app }) {
    await store.dispatch('artist/getList', {
      isServerRender: !!(app.context && app.context.ssrContext),
      isSubPageGoBack: !!(app.context && app.context.from && app.context.from.fullPath.startsWith('/artists/')),
      lang: app.i18n.getLocaleCookie()
    })
  },
  computed: {
    ...mapState({
      list: state => state.artist.list,
      pages: state => state.artist.pages,
      current: state => state.artist.current
    })
  },
  methods: {
    async loadMore () {
      if (this.current > this.pages || this.loading) {
        return
      }

      this.loading = true
      await this.$store.dispatch('artist/getList', {
        lang: this.$i18n.getLocaleCookie()
      })

      setTimeout(() => {
        this.loading = false
      }, 1000)
    },

    handlePaste (event) {
      // 禁用鼠标右键
      event.preventDefault()
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 77px 0 16px;

  .title {
    margin-bottom: 60px;
    color: #000000;
    text-align: center;
    font-size: 24px;
  }

  .list-wrap {
    display: flex;
    flex-wrap: wrap;
  }

  .item-wrap {
    position: relative;
    margin-right: 42px;
    margin-bottom: 50px;
    width: 288px;

    &:nth-child(4n + 4) {
      margin-right: 0;
    }

    .normal-img {
      width: 288px;
      height: 288px;

      object-fit: contain;
    }

    p {
      margin-top: 28px;
      color: #000000;
      font-weight: bold;
      font-size: 22px;
      line-height: 1;

      @include clamps-text-overflow(1);
    }
  }

  .loading {
    margin: 20px 0;
    text-align: center;
  }
}
</style>
